import React, { Component } from 'react';
import './Settings.css';

class Settings extends Component {
  render() {
    return (
      <div>
        <h1 data-testid="settings-title" className="geral-page-settings ">Settings</h1>
      </div>
    );
  }
}

export default Settings;
